/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:18:22
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P7 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title4 pageNumber="2.2">安踏VS竞品｜主要传播关键词对比</Title4>

        <div className={s.content}>
          <div contentEditable className={s.subTitle}>均更侧重在社交媒体端的曝光度，安踏的“奥运”“科技”标签深入人心</div>
          <div contentEditable className={s.des}>
          安踏和竞品的多个传播关键词在社交媒体端被提及的频次远高于新闻媒体端。综合来看，安踏除“ 国潮/国产/国货”关键词的曝光度略低于李宁外，其它传播关键词曝光频次均高于竞品，其中，“奥运/冬奥”“科技/技术/专利/发明”表现更为突出，多种高科技加持的产品助力冬奥会，使得安踏的科技实力进一步获得认可。
          </div>
          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart options={setChart({ label: chartTitle, list: chartList, color: chartColorList })} />
            </TooltipDrawer>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P7);



// WEBPACK FOOTER //
// src/routes/visualChart/P7/index.js